<div class="search-field d-flex">
  <i class="icon icon-search text-lightgray clickable p-1" (click)="handleApply()"></i>
  <ng-content></ng-content>
  <i [hidden]="!input?.value" (click)="handleClear()" class="icon icon-clear clickable p-1"></i>
</div>
